import { AuthRest } from "@/services/rest/auth.rest";
import { Observable, Subject } from "rxjs";
export class LoginServices {
  constructor(private _loginRest = new AuthRest()) {}

  user$: Subject<any> = new Subject<any>();
  user: Observable<any> = this.user$.asObservable();
}
